import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const loginUserRequest = ({username,password,token}) => {
    const config = {
        path: 'login',
        method: 'POST',
        headers: {
            token: token
        },
        body: {
            user: username,
            password: password
        }
    };
    return FetchByObjectConfig(config);
}